<template>
    <div class="tw-container tw-max-w-5xl tw-m-auto tw-p-2">
        <div class="tw-text-3xl">New Campaign</div>
        <div class="tw-p-4 tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-grid-flow-row">
            <div class="md:tw-col-span-1 tw-p-1">
                <TField label="Name">
                    <TInput v-model="name"></TInput>
                </TField>
            </div>
            <div class="md:tw-col-span-1 tw-p-1">
                <TField label="Tags">
                    <TTagInput v-model="tags"></TTagInput>
                </TField>
            </div>
            <div class="md:tw-col-span-2 tw-p-1">
                <TField label="Description">
                    <TInput type="textarea" v-model="description"></TInput>
                </TField>
            </div>
        </div>
        <div class="tw-p-4 tw-flex tw-items-center tw-justify-end">
            <TButton :disabled="!name || !description" @click="save" class="tw-mr-2 tw-text-white tw-bg-blue-600 hover:tw-bg-blue-500">Save</TButton>
            <TButton @click="$router.back()" class="tw-bg-white tw-border tw-border-gray-500 tw-text-gray-900 hover:tw-border-gray-400 hover:tw-bg-white">Cancel</TButton>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import {
    TInput,
    TField,
    TButton,
    TTagInput,
} from '@roonlabs/vue-tailwind';

export default {
    components: {TTagInput, TInput, TField, TButton},
    props: {
        campaign_id: String
    },
    data() {
        return {
            loading:     true,
            name:        '',
            description: '',
            tags:        [],
        }
    },
    async created() {
        if ( this.campaign_id ) {
            try { 
                const res = await axios.get('/api/1/campaigns/' + this.campaign_id);
                const { campaign } = res.data;

                this.name        = campaign.name;
                this.description = campaign.description;
                this.tags        = campaign.tags;
            } catch (e) {
                console.log(e);
            }
        }
        this.loading = false;
    },
    methods: {
        async save() {
            this.loading = true;
            try {
                const body = {
                    name:        this.name,
                    description: this.description,
                    tags:        this.tags, 
                };

                let res;
                if ( this.campaign_id ) {
                    body.campaign_id = this.campaign_id;
                    res = await axios.put('/api/1/campaigns', body);
                } else {
                    res = await axios.post('/api/1/campaigns', body);
                }
                const { campaign } = res.data;
                this.$router.replace({ name: 'Campaign', params: { campaign_id: campaign.campaign_id }})
            } catch (e) {
                console.log(e);
            }
            this.loading = false;
        }
    }

}
</script>



